module.exports = "&nbsp;<span [title]=\"tooltip\"><i class=\"fas fa-lg fa-info-circle\" ></i></span>"